export default __webpack_public_path__ + "static/media/phonestore.3ea1b6d8.png";